import { Route } from './+types/catch-all';

/**
 * "Catch all" route - matches all unknown URL paths.
 * It's important e.g. for redirects - if unknown routes wouldn't be matched by any route,
 * root loader wouldn't be triggered and redirects would have no chance to work.
 */
export const loader = ({ params }: Route.LoaderArgs) => {
  const { '*': splat } = params;

  // If execution came up to this point, it means no other route or redirect (in root loader) was matched,
  // so the only thing left is 404.
  throw new Response(null, { status: 404, statusText: `${splat} not found` });
};

export default function Component() {
  return null;
}
